import React, { useMemo, useState, useEffect, useRef } from 'react';
import Popover from '@/components/popover';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import cs from './index.module.scss';
import { QRCodeSVG } from 'qrcode.react';
import { useHistory } from 'react-router-dom';
import DropDownSettingMenu from './components/DropDownSettingMenu';
import DownloadIcon from '@/components/icons/DownloadIcon';
import MessageIcon from '@/components/icons/MessageIcon';
import GlobalIcon from '@/components/icons/GlobalIcon';
import { useStore } from '@/models';
import { LANG_LIST } from '@/config/const';
import { useLocation } from 'react-router-dom';
import HeaderCustomerIcon from '@/components/icons/HeaderCustomerIcon';
import { initZendeskWidget, openZendeskChat } from '@/config/zendesk';

declare global {
  interface Window {
    zE: any;
    secur: {
      device: string;
    };
  }
}

const Setting: React.FC = () => {
  const { t } = useTranslation();
  const { account, home, spot } = useStore();

  const location = useLocation(); // 获取路由信息
  const showCustomerIcon = location.pathname.includes('futures/contract/u_based'); // 判断路由

  const { userInfo } = account;

  const {
    id,
    email,
    username,
    tel,
    createTime,
    emailSecurityStatus,
    googleSecurityStatus,
    phoneSecurityStatus,
    idNoStatus,
    securityLevel,
  } = userInfo;
  const {
    currencyConfig,
    lang,
    systemCircle,
    dwCircle,
    safeCircle,
    authCircle,
    copyOrderCircle,
    contractCircle,
    isLogin,
    alwaysSportListenKey,
    fetchZnxListAll,
    fetchZnxList,
    fetchAlwaysSportListenKey,
  } = account;

  const initZendesk = () => {
    // 使用配置文件中的初始化函数
    initZendeskWidget(isLogin ? userInfo : null, lang);
  };

  useEffect(() => {
    // 登录后立即完成 Zendesk JWT 认证预热，不等待点击客服按钮
    initZendesk();
  }, [isLogin, userInfo?.id, lang]);

  useEffect(() => {
    if (showCustomerIcon) {
      initZendesk();
    }
  }, [showCustomerIcon, lang]);

  const showChatBox = () => {
    if (showCustomerIcon) {
      initZendesk();
    }
    openZendeskChat();
  };

  const { confList } = home;
  const { larding_page_url } = confList;
  const { userSocket, createUserSocket } = spot;
  const timer = useRef<any>(null);
  const [times, setTimes] = useState(1);
  const { push } = useHistory();

  const [rateVisible, setRateVisible] = useState(false);
  const currentLang = useMemo(() => {
    console.log('lang', lang)
    const temp = LANG_LIST.find((item: any) => lang === item.value);
    if (temp) {
      return temp.label;
    }
    return ''; // 添加默认返回值
  }, [lang]);
  // Begin: download app
  const downloadWrapper = () => (
    <div className={cx(cs.qrBox)}>
      <div className={cx(cs.qr)}>
        <QRCodeSVG value={larding_page_url} size={116} />
      </div>

      <div className={cx(cs.text)}>{t('btn.scanAndDown')}</div>
    </div>
  );
  // End: download app

  const selectHandle = () => {
    setRateVisible(false);
  };
  useEffect(() => {
    if (isLogin) {
      !userSocket && createUserSocket();
      fetchAlwaysSportListenKey();
      fetchZnxListAll();
    }

    return () => {
      if (isLogin && userSocket) {
        userSocket.offClient('message', messageCallback);
        userSocket.unEmitAboutUser();
      }
    };
  }, [isLogin]);
  const messageCallback = (res: any) => {
    if (res?.resType === 'znxMessage') {
      setTimes(Date.now());
      decrement(res?.data.aggType);
    }
  };
  const test = () => {
    messageCallback({ resType: 'znxMessage', data: { aggType: 'DEPOSIT_WITHDRAW' } });
  };

  useEffect(() => {
    if (alwaysSportListenKey) {
      if (userSocket) {
        userSocket.onClient('message', messageCallback);
        userSocket.emitAboutUser(alwaysSportListenKey);
      }
    }

    return () => {
      if (userSocket) {
        userSocket.offClient('message', messageCallback);
      }
    };
  }, [alwaysSportListenKey, userSocket]);
  const decrement = (aggType: string) => {
    // if (times === 1) {
    //   fetchZnxList({
    //     aggType,
    //   });
    //   return;
    // }
    if (timer.current === null) {
      timer.current = setInterval(() => {
        if (Date.now() - times > 5000) {
          fetchZnxList({
            aggType,
          });
        }
      }, 5000);
    }
  };
  useEffect(
    () => () => {
      clearInterval(timer.current);
    },
    [],
  );
  function replaceSubdomainWithCopyWeb() {
    const { protocol, hostname, port } = window.location;
    const parts = hostname.split('.');
    if (parts.length > 2) {
      parts[0] = 'copy-web';
    } else if (parts.length === 2) {
      parts.unshift('copy-web');
    }
    const newHostname = parts.join('.');
    const newUrl = `${protocol}//${newHostname}${port ? `:${port}` : ''}`;
    return newUrl;
  }

  const handleToWelfare = () => {
    const newUrl = replaceSubdomainWithCopyWeb();
    if (isLogin) {
      window.open('/' + lang + '/welfare-hub/home', '_blank');
    } else {
      window.open('/' + lang + '/login', '_self');
    }
  };

  return (
    <div className={cx(cs.container)}>
      <ul className={cx('header-ul')}>
        {showCustomerIcon && (
          <li onClick={() => showChatBox()}>
            <a href="javascript:void(0)">
            <HeaderCustomerIcon style={{ color: '#333333' }} />
            </a>

          </li>
        )}
        {isLogin && (
          <li>
            {/* <Popover placement="bottom-end" content={<DropDownSettingMenu />} width={460}> */}
            <a className={cs.message} href="/message/SYSTEM">
              <MessageIcon style={{ color: '#333333' }} />
              {(systemCircle || dwCircle || safeCircle || authCircle || copyOrderCircle || contractCircle) && (
                <i className={cx(cs.red)} />
              )}
              {/* <span className={cx(cs.title)}>
                {currentLang}/{currencyConfig.label}
              </span>  */}
            </a>
            {/* </Popover> */}
          </li>
        )}
        {/* <li>
          <span onClick={handleToWelfare}>
            <img src="/assets/welfare-hub/welfare-logo.png" width={20} height={20} />
          </span>
        </li> */}
        <li>
          <Popover placement="bottom-end" content={<DropDownSettingMenu />} width={150}>
            <a>
              <GlobalIcon style={{ color: '#333333' }} />
              <span className={cx(cs.title)}>
                {/* {currentLang}/{currencyConfig.label} */}
                {/* {currentLang} */}
                {/* <i className={cx('iconfont icon-select_drop', cs.dropDown)} /> */}
              </span>
            </a>
          </Popover>
        </li>

        {/* <li onMouseEnter={() => setRateVisible(true)}>
          <Popover placement="bottom-end" visible={rateVisible} width={116} content={<Rate select={selectHandle} />}>
            <a>{currencyConfig.label}</a>
          </Popover>
        </li> */}

        <li>
          <Popover placement="bottom-end" content={downloadWrapper()} style={{borderRadius: '16px'}} width={220}>
            <a href="javascript:void(0);">
              <DownloadIcon style={{ color: '#333333' }} />
            </a>
          </Popover>
        </li>
      </ul>
    </div>
  );
};

export default observer(Setting);
